import React from 'react';
import styled from '@emotion/styled';

const Frame = styled.div({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
});

const VizPane = styled.div({
    flexGrow: 1,
    width: '100%',
    height: '100%',
});

const QueuePane = styled.div({
    flexShrink: 0,
    width: 'fit-content',
    height: '100%',
});

export type RTCLayoutProps = {
    viz: React.ReactElement;
    queue?: React.ReactElement;
};

export function RTCLayout(props: RTCLayoutProps) {
    const { viz, queue } = props;

    return (
        <Frame>
            <VizPane>{viz}</VizPane>
            <QueuePane>{queue}</QueuePane>
        </Frame>
    );
}
